import React, { useState, useCallback } from 'react';

// Utilities
import { isElementOfType, sanitizeFragments } from '../../utilities/components';

// Components
import WpCollapsibleGroupItem from './WpCollapsibleGroupItem';

// Styles
import './WpCollapsibleGroup.scss';

type Props = {
  children: React.ReactNode;
  defaultOpenIds?: string[];
  multiOpen?: boolean;
  numbered?: boolean;
};

const WpCollapsibleGroup = ({ children, multiOpen = true, defaultOpenIds = [], numbered = true }: Props) => {
  const [activeIds, setActiveIds] = useState<string[]>(defaultOpenIds);
  const sanitizedChildren = children && sanitizeFragments(children);

  const handleUpdateActiveIds = useCallback(
    (id: string) => {
      if (activeIds.includes(id)) {
        setActiveIds(activeIds.filter(item => item !== id));
      } else if (multiOpen) {
        setActiveIds([...activeIds, id]);
      } else {
        setActiveIds([id]);
      }
    },
    [activeIds]
  );

  const baseClassName = 'WpCollapsibleGroup';

  return (
    <div className={baseClassName}>
      {React.Children.map(sanitizedChildren, (child: React.ReactElement<any>, index: number) => {
        if (child && isElementOfType(child, WpCollapsibleGroupItem)) {
          return React.cloneElement(child, {
            isOpen: activeIds.includes(child.props.collapsibleId),
            onClick: handleUpdateActiveIds,
            number: numbered ? index + 1 : null,
          });
        } else return null;
      })}
    </div>
  );
};

export default WpCollapsibleGroup;
